import React from 'react';
import {
    Page,
    Text,
    View,
    Document
} from '@react-pdf/renderer';
import {VaccineModel} from '../../../model/vaccine.model';
import {ResultsModel} from '../../../model/results.model';


interface PdfProps {
    t: (key: string) => string;
    resultsCtx: ResultsModel;
    finalVaccinations: {
        mandatoryVaccinations: VaccineModel[],
        recommendedVaccinations: VaccineModel[],
        highlyRecommendedVaccinations: VaccineModel[],
        contraindicatedVaccinations: VaccineModel[]
    }
}


const Pdf: React.FC<PdfProps> = ({t, resultsCtx, finalVaccinations}: PdfProps) => (
    <Document>
        <Page size="A4" style={
            {
                fontFamily: "HelveticaNeueLight",
                display: "flex",
                flexDirection: "column",
                backgroundColor: "#fff",
                padding: 30,
                gap: 20
            }
        }>

            {finalVaccinations.mandatoryVaccinations.length &&
                <View
                    wrap={false}
                    style={
                    {
                        padding: 5,
                        backgroundColor: "#f5f5f5",
                        border: "1pt solid #ddd",
                        borderRadius: 12
                    }
                }>
                    <Text style={
                        {
                            fontSize: 14,
                            marginTop: 10,
                            marginBottom: 10,
                            textAlign: "left",
                            fontWeight: "bold",
                            paddingLeft: 8
                        }
                    }>
                        {t('mandatory')}
                    </Text>
                    <View>
                        {finalVaccinations.mandatoryVaccinations.map((vaccination: VaccineModel) => (
                            <View style={
                                {
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "flex-start",
                                    alignContent: "center",
                                    gap: 2,
                                    margin: 4,
                                    padding: 4,
                                    backgroundColor: "#fff",
                                    borderRadius: 8,
                                    fontSize: 10
                                }
                            }>

                                <View style={
                                    {
                                        width: "100%"
                                    }
                                }>
                                    <View style={
                                        {
                                            width: "100%",
                                            backgroundColor: "#c0c0c0",
                                            borderRadius: 4,
                                            paddingTop: 7,
                                            paddingBottom: 4
                                        }
                                    }>
                                        <Text style={
                                            {
                                                fontSize: 10,
                                                fontWeight: "bold",
                                                paddingLeft: 10
                                            }
                                        }>
                                            {vaccination.fullName}
                                        </Text>
                                    </View>


                                    {((resultsCtx.birthDate_18_to_49 && vaccination.vaccinationSchema_18_49 !== "") ||
                                            (resultsCtx.birthDate_50_to_54 && vaccination.vaccinationSchema_50_54 !== "") ||
                                            (resultsCtx.birthDate_55_to_59 && vaccination.vaccinationSchema_55_59 !== "") ||
                                            (resultsCtx.birthDate_60_to_64 && vaccination.vaccinationSchema_60_64 !== "") ||
                                            (resultsCtx.birthDate_over_65 && vaccination.vaccinationSchema_65 !== "")) &&

                                        <View style={
                                            {
                                                width: "100%"
                                            }
                                        }>
                                            <Text style={{
                                                fontSize: 9,
                                                textDecoration: "underline",
                                                paddingTop: 5,
                                                paddingLeft: 10
                                            }}>
                                                {t('table_header_vaccination_schema')}:
                                            </Text>
                                            <Text style={{
                                                fontSize: 9,
                                                paddingLeft: 10,
                                                paddingTop: 2
                                            }}>

                                                {(resultsCtx.birthDate_18_to_49 && vaccination.vaccinationSchema_18_49 !== "") && vaccination.vaccinationSchema_18_49}
                                                {(resultsCtx.birthDate_50_to_54 && vaccination.vaccinationSchema_50_54 !== "") && vaccination.vaccinationSchema_50_54}
                                                {(resultsCtx.birthDate_55_to_59 && vaccination.vaccinationSchema_55_59 !== "") && vaccination.vaccinationSchema_55_59}
                                                {(resultsCtx.birthDate_60_to_64 && vaccination.vaccinationSchema_60_64 !== "") && vaccination.vaccinationSchema_60_64}
                                                {(resultsCtx.birthDate_over_65 && vaccination.vaccinationSchema_65 !== "") && vaccination.vaccinationSchema_65}
                                            </Text>
                                        </View>
                                    }

                                    {vaccination.disclaimer.length > 0 &&
                                        <View>
                                            <Text style={{
                                                fontSize: 9,
                                                textDecoration: "underline",
                                                paddingTop: 5,
                                                paddingLeft: 10
                                            }}>
                                                {t('table_header_disclaimer')}:
                                            </Text>
                                            <Text style={{
                                                fontSize: 9,
                                                paddingLeft: 10,
                                                paddingTop: 2
                                            }}>
                                                {vaccination.disclaimer}
                                            </Text>
                                        </View>
                                    }

                                </View>

                            </View>
                        ))}
                    </View>
                </View>
            }


            {finalVaccinations.highlyRecommendedVaccinations.length &&
                <View
                    wrap={false}
                    style={
                    {
                        padding: 5,
                        backgroundColor: "#f5f5f5",
                        border: "1pt solid #ddd",
                        borderRadius: 12
                    }
                }>
                    <Text style={
                        {
                            fontSize: 14,
                            marginTop: 10,
                            marginBottom: 10,
                            textAlign: "left",
                            fontWeight: "bold",
                            paddingLeft: 8
                        }
                    }>
                        {t('highly_recommended')}
                    </Text>
                    <View>
                        {finalVaccinations.highlyRecommendedVaccinations.map((vaccination: VaccineModel) => (
                            <View style={
                                {
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "flex-start",
                                    alignContent: "center",
                                    gap: 2,
                                    margin: 4,
                                    padding: 4,
                                    backgroundColor: "#fff",
                                    borderRadius: 8,
                                    fontSize: 10
                                }
                            }>


                                <View style={
                                    {
                                        width: "100%"
                                    }
                                }>
                                    <View style={
                                        {
                                            width: "100%",
                                            backgroundColor: "#c0c0c0",
                                            borderRadius: 4,
                                            paddingTop: 7,
                                            paddingBottom: 4
                                        }
                                    }>
                                        <Text style={
                                            {
                                                fontSize: 10,
                                                fontWeight: "bold",
                                                paddingLeft: 10
                                            }
                                        }>
                                            {vaccination.fullName}
                                        </Text>
                                    </View>


                                    {((resultsCtx.birthDate_18_to_49 && vaccination.vaccinationSchema_18_49 !== "") ||
                                            (resultsCtx.birthDate_50_to_54 && vaccination.vaccinationSchema_50_54 !== "") ||
                                            (resultsCtx.birthDate_55_to_59 && vaccination.vaccinationSchema_55_59 !== "") ||
                                            (resultsCtx.birthDate_60_to_64 && vaccination.vaccinationSchema_60_64 !== "") ||
                                            (resultsCtx.birthDate_over_65 && vaccination.vaccinationSchema_65 !== "")) &&

                                        <View style={
                                            {
                                                width: "100%"
                                            }
                                        }>
                                            <Text style={{
                                                fontSize: 9,
                                                textDecoration: "underline",
                                                paddingTop: 5,
                                                paddingLeft: 10
                                            }}>
                                                {t('table_header_vaccination_schema')}:
                                            </Text>
                                            <Text style={{
                                                fontSize: 9,
                                                paddingLeft: 10,
                                                paddingTop: 2
                                            }}>

                                                {(resultsCtx.birthDate_18_to_49 && vaccination.vaccinationSchema_18_49 !== "") && vaccination.vaccinationSchema_18_49}
                                                {(resultsCtx.birthDate_50_to_54 && vaccination.vaccinationSchema_50_54 !== "") && vaccination.vaccinationSchema_50_54}
                                                {(resultsCtx.birthDate_55_to_59 && vaccination.vaccinationSchema_55_59 !== "") && vaccination.vaccinationSchema_55_59}
                                                {(resultsCtx.birthDate_60_to_64 && vaccination.vaccinationSchema_60_64 !== "") && vaccination.vaccinationSchema_60_64}
                                                {(resultsCtx.birthDate_over_65 && vaccination.vaccinationSchema_65 !== "") && vaccination.vaccinationSchema_65}
                                            </Text>
                                        </View>
                                    }

                                    {vaccination.disclaimer.length > 0 &&
                                        <View>
                                            <Text style={{
                                                fontSize: 9,
                                                textDecoration: "underline",
                                                paddingTop: 5,
                                                paddingLeft: 10
                                            }}>
                                                {t('table_header_disclaimer')}:
                                            </Text>
                                            <Text style={{
                                                fontSize: 9,
                                                paddingLeft: 10,
                                                paddingTop: 2
                                            }}>
                                                {vaccination.disclaimer}
                                            </Text>
                                        </View>
                                    }


                                </View>

                            </View>
                        ))}
                    </View>
                </View>
            }


            {finalVaccinations.recommendedVaccinations.length &&
                <View
                    wrap={false}
                    style={
                    {
                        padding: 5,
                        backgroundColor: "#f5f5f5",
                        border: "1pt solid #ddd",
                        borderRadius: 12
                    }
                }>
                    <Text style={
                        {
                            fontSize: 14,
                            marginTop: 10,
                            marginBottom: 10,
                            textAlign: "left",
                            fontWeight: "bold",
                            paddingLeft: 8
                        }
                    }>
                        {t('recommended')}
                    </Text>
                    <View>
                        {finalVaccinations.recommendedVaccinations.map((vaccination: VaccineModel) => (
                            <View style={
                                {
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "flex-start",
                                    alignContent: "center",
                                    gap: 2,
                                    margin: 4,
                                    padding: 4,
                                    backgroundColor: "#fff",
                                    borderRadius: 8,
                                    fontSize: 10
                                }
                            }>


                                <View style={
                                    {
                                        width: "100%"
                                    }
                                }>
                                    <View style={
                                        {
                                            width: "100%",
                                            backgroundColor: "#c0c0c0",
                                            borderRadius: 4,
                                            paddingTop: 7,
                                            paddingBottom: 4
                                        }
                                    }>
                                        <Text style={
                                            {
                                                fontSize: 10,
                                                fontWeight: "bold",
                                                paddingLeft: 10
                                            }
                                        }>
                                            {vaccination.fullName}
                                        </Text>
                                    </View>


                                    {((resultsCtx.birthDate_18_to_49 && vaccination.vaccinationSchema_18_49 !== "") ||
                                            (resultsCtx.birthDate_50_to_54 && vaccination.vaccinationSchema_50_54 !== "") ||
                                            (resultsCtx.birthDate_55_to_59 && vaccination.vaccinationSchema_55_59 !== "") ||
                                            (resultsCtx.birthDate_60_to_64 && vaccination.vaccinationSchema_60_64 !== "") ||
                                            (resultsCtx.birthDate_over_65 && vaccination.vaccinationSchema_65 !== "")) &&

                                        <View style={
                                            {
                                                width: "100%"
                                            }
                                        }>
                                            <Text style={{
                                                fontSize: 9,
                                                textDecoration: "underline",
                                                paddingTop: 5,
                                                paddingLeft: 10
                                            }}>
                                                {t('table_header_vaccination_schema')}:
                                            </Text>
                                            <Text style={{
                                                fontSize: 9,
                                                paddingLeft: 10,
                                                paddingTop: 2
                                            }}>

                                                {(resultsCtx.birthDate_18_to_49 && vaccination.vaccinationSchema_18_49 !== "") && vaccination.vaccinationSchema_18_49}
                                                {(resultsCtx.birthDate_50_to_54 && vaccination.vaccinationSchema_50_54 !== "") && vaccination.vaccinationSchema_50_54}
                                                {(resultsCtx.birthDate_55_to_59 && vaccination.vaccinationSchema_55_59 !== "") && vaccination.vaccinationSchema_55_59}
                                                {(resultsCtx.birthDate_60_to_64 && vaccination.vaccinationSchema_60_64 !== "") && vaccination.vaccinationSchema_60_64}
                                                {(resultsCtx.birthDate_over_65 && vaccination.vaccinationSchema_65 !== "") && vaccination.vaccinationSchema_65}
                                            </Text>
                                        </View>
                                    }

                                    {vaccination.disclaimer.length > 0 &&
                                        <View>
                                            <Text style={{
                                                fontSize: 9,
                                                textDecoration: "underline",
                                                paddingTop: 5,
                                                paddingLeft: 10
                                            }}>
                                                {t('table_header_disclaimer')}:
                                            </Text>
                                            <Text style={{
                                                fontSize: 9,
                                                paddingLeft: 10,
                                                paddingTop: 2
                                            }}>
                                                {vaccination.disclaimer}
                                            </Text>
                                        </View>
                                    }

                                </View>

                            </View>
                        ))}
                    </View>
                </View>
            }


            {finalVaccinations.contraindicatedVaccinations.length &&
                <View
                    wrap={false}
                    style={
                    {
                        padding: 5,
                        backgroundColor: "#f5f5f5",
                        border: "1pt solid #ddd",
                        borderRadius: 12
                    }
                }>
                    <Text style={
                        {
                            fontSize: 14,
                            marginTop: 10,
                            marginBottom: 10,
                            textAlign: "left",
                            fontWeight: "bold",
                            paddingLeft: 8
                        }
                    }>
                        {t('contraindicated')}
                    </Text>
                    <View>
                        {finalVaccinations.contraindicatedVaccinations.map((vaccination: VaccineModel) => (
                            <View style={
                                {
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "flex-start",
                                    alignContent: "center",
                                    gap: 2,
                                    margin: 4,
                                    padding: 4,
                                    backgroundColor: "#fff",
                                    borderRadius: 8,
                                    fontSize: 10
                                }
                            }>


                                <View style={
                                    {
                                        width: "100%"
                                    }
                                }>
                                    <View style={
                                        {
                                            width: "100%",
                                            backgroundColor: "#c0c0c0",
                                            borderRadius: 4,
                                            paddingTop: 7,
                                            paddingBottom: 4
                                        }
                                    }>
                                        <Text style={
                                            {
                                                fontSize: 10,
                                                fontWeight: "bold",
                                                paddingLeft: 10
                                            }
                                        }>
                                            {vaccination.fullName}
                                        </Text>
                                    </View>


                                    {((resultsCtx.birthDate_18_to_49 && vaccination.vaccinationSchema_18_49 !== "") ||
                                            (resultsCtx.birthDate_50_to_54 && vaccination.vaccinationSchema_50_54 !== "") ||
                                            (resultsCtx.birthDate_55_to_59 && vaccination.vaccinationSchema_55_59 !== "") ||
                                            (resultsCtx.birthDate_60_to_64 && vaccination.vaccinationSchema_60_64 !== "") ||
                                            (resultsCtx.birthDate_over_65 && vaccination.vaccinationSchema_65 !== "")) &&

                                        <View style={
                                            {
                                                width: "100%"
                                            }
                                        }>
                                            <Text style={{
                                                fontSize: 9,
                                                textDecoration: "underline",
                                                paddingTop: 5,
                                                paddingLeft: 10
                                            }}>
                                                {t('table_header_vaccination_schema')}:
                                            </Text>
                                            <Text style={{
                                                fontSize: 9,
                                                paddingLeft: 10,
                                                paddingTop: 2
                                            }}>

                                                {(resultsCtx.birthDate_18_to_49 && vaccination.vaccinationSchema_18_49 !== "") && vaccination.vaccinationSchema_18_49}
                                                {(resultsCtx.birthDate_50_to_54 && vaccination.vaccinationSchema_50_54 !== "") && vaccination.vaccinationSchema_50_54}
                                                {(resultsCtx.birthDate_55_to_59 && vaccination.vaccinationSchema_55_59 !== "") && vaccination.vaccinationSchema_55_59}
                                                {(resultsCtx.birthDate_60_to_64 && vaccination.vaccinationSchema_60_64 !== "") && vaccination.vaccinationSchema_60_64}
                                                {(resultsCtx.birthDate_over_65 && vaccination.vaccinationSchema_65 !== "") && vaccination.vaccinationSchema_65}
                                            </Text>
                                        </View>
                                    }

                                    {vaccination.disclaimer.length > 0 &&
                                        <View>
                                            <Text style={{
                                                fontSize: 9,
                                                textDecoration: "underline",
                                                paddingTop: 5,
                                                paddingLeft: 10
                                            }}>
                                                {t('table_header_disclaimer')}:
                                            </Text>
                                            <Text style={{
                                                fontSize: 9,
                                                paddingLeft: 10,
                                                paddingTop: 2
                                            }}>
                                                {vaccination.disclaimer}
                                            </Text>
                                        </View>
                                    }


                                </View>

                            </View>
                        ))}
                    </View>
                </View>
            }

        </Page>
    </Document>
);
export default Pdf;
